import { getUsersByIds } from './GetUsersByIds';
import { getInternalUsers } from './GetInternalUsers';
import { getInternalUserMe } from './GetInternalUserMe';
import { getInternalUsersByRole } from './GetInternalUsersByRole';
import { getRecruiters } from './GetRecruiters';
import { getChildOffices } from './GetChildOffices';
import { getOffice } from './GetOffice';
import { getNpsReviews } from './GetNpsReviews';

/**
 * Users Service
 * Provides business logic layer for users operations
 */
export const UsersService = {
  getUsersByIds,
  getInternalUsers,
  getInternalUserMe,
  getInternalUsersByRole,
  getRecruiters,
  getChildOffices,
  getOffice,
  getNpsReviews,
};
